export const FilterSearch = (array: any[], keyword: string) => {
  const searchTerm = keyword.toLowerCase()
  return array.filter(value => {
    return value.name.toLowerCase().match(new RegExp(searchTerm, 'g'))
  })
}
